import "./Headline.css";
const Headline = ({text}) => {
    return (
        <>
            <div className="textInsideHeadline">
                <span>{text}</span>
                <span>{text}</span>
            </div>
        </>
    )
}
export default Headline;